import EducationClassEdit from "../Edits/EducationClassEdit";
import CmModal from "../Controls/CmModal";

export default function EducationClassEditModal({
  initialClass = null,
  isNew = false,
  onSave,
  onClose,
}) {
  const title = isNew ? "Add Class" : "Class";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="education-class-edit-modal"
    >
      <EducationClassEdit initialClass={initialClass} onSave={onSave} onClose={onClose} />
    </CmModal>
  );
}
